import * as React from 'react';
import { ILinks6Data } from '../obrien-ff.props.autogenerated';

export interface IContentCardLinks6 {
    links6: ILinks6Data[];
}

const ContentCardLinks6: React.FC<IContentCardLinks6> = ({ links6 }) => (
    <div className='ms-content-block__cta'>
        {links6.map((cta: ILinks6Data, index: number) => {
            const btnClass = index === 0 ? 'msc-cta__primary' : 'msc-cta__secondary';
            return <a
                key={`link-${index}`}
                className={btnClass}
                role='button'
                title={cta.linkText}
                href={cta.linkUrl && cta.linkUrl.destinationUrl}
                aria-label={cta.ariaLabel}
                target={cta.openInNewTab ? '_blank' : undefined}
            >
                <span>{cta.linkText}</span>
            </a>;
        })}
    </div>
);

export default ContentCardLinks6;